export default "__VITE_ASSET__KtlLv$yj__"